const state = {
  oneTimeParams: null
}

//
const mutations = {
  setOneTimeParams(state, params) {
    state.oneTimeParams = params
  },
  resetOneTimeParams(state) {
    state.oneTimeParams = null
  }
}

//
const actions = {
  setOneTimeParams({ commit }, params) {
    commit('setOneTimeParams', params)
  },
  getOneTimeParams({ commit, state }) {
    const oneTimeParams = state.oneTimeParams
    commit('resetOneTimeParams')
    if (oneTimeParams) {
      return oneTimeParams
    } else {
      return null
    }
  }
}

//
export const conversation = {
  namespaced: true,
  state,
  actions,
  mutations
}
